import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from '@env/environment';
import { HttpErrorLike } from '@core/models/http-error-like.model';
import { httpErrorMessage } from '@core/utils/http-error';

const API_URL = `${environment.apiUrl}/invitations`;

export interface InvitationResponse {
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class EmploymentInvitationService {
  private http = inject(HttpClient);

  respond(token: string, action: 'accept' | 'decline'): Observable<InvitationResponse> {
    const body = { token, action };

    return this.http
      .post<InvitationResponse>(`${API_URL}/respond`, body)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorLike) {
    const errorMessage =
      httpErrorMessage(error) ?? 'Ocurrió un error desconocido. Por favor, intenta de nuevo.';

    return throwError(() => new Error(errorMessage));
  }
}
